import { gql } from '@apollo/client'
import { BRAND_FRAGMENT } from './BrandFragment'
import { MANUFACTURER_FRAGMENT } from './ManufacturerFragment'
import { PACKAGING_FRAGMENT } from './PackagingFragment'

export const PRODUCT_PRICE_OBJECT_FRAGMENT = gql`
  fragment ProductPriceObject on ProductPriceObject {
    id
    forStoreType
    packaging {
      ...Packaging
    }
    brand {
      ...Brand
    }
    manufacturer {
      ...Manufacturer
    }
    category {
      id
      category
    }
  }
  ${PACKAGING_FRAGMENT}
  ${BRAND_FRAGMENT}
  ${MANUFACTURER_FRAGMENT}
`
